import { all } from 'redux-saga/effects';

import watchApiCall from './api';
import watchUserLogin from './loginSaga';
import watchUserSignUp from './signUpSaga';
import watchOrdersList from './ordersListSaga';
import watchEmployeesList from './employeesListSaga';
import watchRestaurantOrders from './restaurantOrdersSaga';
import watchRestaurantOrder from './restaurantOrderSaga';
import watchEmployee from './employeeSaga';
import watchCompanyHomeDetails from './companyHomeSaga';
import watchbulkUpload from './bulkUploadSaga';
import watchCompanyReports from './companyReportsSaga';
import watchEmployeeHomeDetails from './employeeHomeSaga';
import watchDownloadReport from './downloadReportSaga';
import watchRestaurantReports from './restaurantReportsSaga';
import watchRestaurantApis from './restaurantSaga';
import watchGetMealDetails from './mealSaga';
import watchCompaniesList from './companiesSaga';
import watchCompany from './companySaga';
import watchRestaurantsList from './restaurantsSaga';
import watchUserForgotPassword from './forgotPasswordSaga';
import watchresetPassword from './resetPasswordSaga';
import watchCompanyRestaurantsMapping from './companyRestaurantsSaga';
import watchRestaurantMeals from './restaurantMealsSaga';

export default function* rootSaga() {
  yield all([
    watchApiCall(),
    watchUserLogin(),
    watchUserSignUp(),
    watchOrdersList(),
    watchEmployeesList(),
    watchRestaurantOrders(),
    watchRestaurantOrder(),
    watchEmployee(),
    watchCompanyHomeDetails(),
    watchbulkUpload(),
    watchCompanyReports(),
    watchEmployeeHomeDetails(),
    watchDownloadReport(),
    watchRestaurantReports(),
    watchRestaurantApis(),
    watchGetMealDetails(),
    watchCompaniesList(),
    watchCompany(),
    watchRestaurantsList(),
    watchUserForgotPassword(),
    watchresetPassword(),
    watchCompanyRestaurantsMapping(),
    watchRestaurantMeals()
  ]);
}
